import ListingEdit from './containers/ListingEditContainer'

export default ListingEdit
